export default __webpack_public_path__ + "static/media/tick.0506e911.jpeg";